import { useSessions } from '@/lib/walletHooks';
import { StatusLabel } from '@/components/ui/StatusLabel';
import { formatCurrencyEurRo, formatDateTimeRo } from '@/lib/format';
import { stopReasonLabel, formatBilledHours } from './format';

export function SesiuniInstanta() {
  const { data: page, isPending, isError } = useSessions(50, 0);
  if (isPending) return <div className="h-40 animate-pulse rounded-2xl bg-wash" aria-hidden />;
  if (isError || !page) return <p className="text-[13.5px] text-bad">Nu s-au putut încărca sesiunile.</p>;
  if (page.items.length === 0) return <p className="text-[13.5px] text-ink-3">Nicio sesiune încă.</p>;
  return (
    <div className="overflow-x-auto">
      <table className="w-full min-w-[560px] text-[13.5px]">
        <thead>
          <tr className="border-b border-rule text-left text-[11.5px] font-bold uppercase tracking-[0.05em] text-ink-3">
            <th className="px-5 py-2.5 font-bold sm:px-6">Început</th>
            <th className="px-5 py-2.5 font-bold sm:px-6">Sfârșit</th>
            <th className="px-5 py-2.5 font-bold sm:px-6">Stare</th>
            <th className="px-5 py-2.5 text-right font-bold sm:px-6">Durată facturată</th>
            <th className="px-5 py-2.5 text-right font-bold sm:px-6">Cost</th>
          </tr>
        </thead>
        <tbody>
          {page.items.map((s) => (
            <tr key={s.id} className="border-b border-rule-soft last:border-b-0 hover:bg-wash">
              <td className="px-5 py-2 tabular-nums text-ink-2 sm:px-6">{formatDateTimeRo(s.startedAt)}</td>
              <td className="px-5 py-2 tabular-nums text-ink-2 sm:px-6">
                {s.stoppedAt ? formatDateTimeRo(s.stoppedAt) : '—'}
              </td>
              <td className="px-5 py-2 sm:px-6">
                {s.stoppedAt === null ? (
                  <StatusLabel tone="teal" label="Activă" pulse />
                ) : (
                  <div className="space-y-0.5">
                    <StatusLabel
                      tone={s.stopReason === 'provision_failed' ? 'bad' : 'mute'}
                      label={stopReasonLabel(s.stopReason)}
                    />
                    {s.stopReason === 'provision_failed' && (
                      <p className="text-[11.5px] text-ink-3">
                        Pornirea a eșuat — suma a fost returnată în portofel.
                      </p>
                    )}
                  </div>
                )}
              </td>
              <td className="px-5 py-2 text-right tabular-nums text-ink-2 sm:px-6">{formatBilledHours(s.billedHours)}</td>
              <td className="px-5 py-2 text-right tabular-nums text-ink-2 sm:px-6">{formatCurrencyEurRo(s.costEur)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
